import {
    ContractExtractionDocument,
    ContractExtractionInput,
    ContractExtractionResponse,
} from '@evidentid/tprm-portal-lib/models/contract-extraction';
import { DocumentDataReviewDocuments } from '@evidentid/tprm-portal-lib/models/document-data-review';
import { TprmRequirementType } from '@evidentid/tprm-portal-lib/models/entity-details';

import { VerificationDocument } from '../models/submission-tprm/VerificationDocument.model';

type RequestMethod = <T = any>(
    method: string,
    requestUrl: string,
    data?: any,
    allowedAdditionalHttpStatuses?: number[],
) => Promise<T>;

function getSubmissionTprmUiRpUrl(commonName: string, path: string): string {
    return encodeURI(`/submission-tprm-ui/rps/${commonName}${path}`);
}

export class SubmissionTprmUiService {
    private readonly request: RequestMethod;
    public constructor(request: RequestMethod) {
        this.request = request;
    }

    public getDocuments(
        {
            cn,
            verId,
            requirement,
            instanceId,
        }: {
            cn: string;
            verId: string;
            requirement: TprmRequirementType;
            instanceId?: string;
        },
    ): Promise<{ documents: VerificationDocument[] | null }> {
        const params = new URLSearchParams();
        params.append('requirement', requirement);
        if (instanceId) {
            params.append('instanceId', instanceId);
        }
        const url = `/submission-tprm-ui/rps/${cn}/verifications/${verId}/documents?${params.toString()}`;
        return this.request('GET', encodeURI(url));
    }

    public getDocumentDataReviewDocuments(
        commonName: string,
        documentDataReviewId: string,
    ): Promise<DocumentDataReviewDocuments> {
        const url = `/submission-tprm-ui/rps/${commonName}/document-data-reviews/${documentDataReviewId}/documents`;
        return this.request('GET', encodeURI(url));
    }

    public createContractExtraction(
        commonName: string,
        payload: ContractExtractionInput,
    ): Promise<ContractExtractionResponse> {
        return this.request('POST', getSubmissionTprmUiRpUrl(commonName, '/contract-extractions'), payload);
    }

    public uploadEntityDocument(
        commonName: string,
        entityId: string,
        payload: { filename: string, document: string, tags?: string[] },
    ): Promise<{ documentId: string, filename: string }> {
        return this.request(
            'POST',
            getSubmissionTprmUiRpUrl(commonName, `/insureds/${entityId}/documents`),
            payload,
        );
    }

    public getEntityDocument(
        commonName: string,
        entityId: string,
        documentId: string,
    ): Promise<{ filename: string, mimeType: string, document: string }> {
        return this.request(
            'GET',
            getSubmissionTprmUiRpUrl(commonName, `/insureds/${entityId}/documents/${documentId}`),
        );
    }

    public getContractExtractionDocument(
        commonName: string,
        contractExtractionId: string,
    ): Promise<ContractExtractionDocument> {
        return this.request(
            'GET',
            getSubmissionTprmUiRpUrl(commonName, `/contract-extractions/${contractExtractionId}/document`),
        );
    }
}
